/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as Cesium from "cesium";
import { Custom3DTileset } from "../types/CesiumMapItems";

export function getTileset(
  fileId: number,
  viewer: Cesium.Viewer,
): Custom3DTileset | null {
  const { primitives } = viewer.scene;
  for (let i = 0; i < primitives.length; i++) {
    const p = primitives.get(i);
    if (p instanceof Cesium.Cesium3DTileset) {
      const ts = p as Custom3DTileset;
      if (ts.fileId === fileId) return ts;
    }
  }
  return null;
}
